import { Monitor } from "lucide-react";

const Footer = () => (
  <footer className="bg-surface text-mute py-12 border-t border-line" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
      <div className="flex items-center gap-2">
        <Monitor className="w-5 h-5 text-brand" strokeWidth={2} />
        <span className="font-mono text-xs uppercase text-ink font-bold" data-testid="footer-legal-name">
          DREAMS SOFT SOLUTIONS PRIVATE LIMITED
        </span>
      </div>
      <div className="text-center md:text-right">
        <p className="font-mono text-xs text-mute">
          PAN-INDIA WAREHOUSE TENDER DIRECTORY & E-PROCUREMENT PLATFORM
        </p>
        <div className="flex items-center justify-center md:justify-end gap-4 mt-3" data-testid="footer-contact-links">
          <a href="tel:+919032290748" className="font-mono text-xs text-brand hover:underline" data-testid="footer-call-link">
            CALL: +91 90322 90748
          </a>
          <a
            href="https://wa.me/919032290748"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-xs text-brand hover:underline"
            data-testid="footer-whatsapp-link"
          >
            WHATSAPP: +91 90322 90748
          </a>
          <a href="/admin" className="font-mono text-xs text-mute hover:text-brand transition-colors" data-testid="footer-admin-link">
            ADMIN
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
